import { HeaderCellProps } from '../types';

export const TenantArchiverHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Archived By</div>;
};
